import prettyPrintKey from "../../../scripts/pretty-print-key";

class EnterpriseAlertTooltips {
  constructor() {
    console.log('init EnterpriseAlertTooltips');

    // Attach mouseover and mouseout events to trigger the tooltip
    $('body').on('mouseover', '.alerts-list-item', (e) => {
      const $target = $(e.currentTarget);
      const alertType = $target.data('for');
      const sensorId = $target.data('sensor');

      // Show the tooltip using the hovered element as the positioning reference
      this.showTooltip(e.currentTarget, alertType, sensorId);
    });

    $('body').on('mouseout', '.alerts-list-item', () => {
      this.hideTooltip();
    });
  }

  // Create a tooltip element if it doesn't exist already
  createTooltipIfNotExists() {
    let tooltipEl = document.getElementById('enterprise-tooltip');
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'enterprise-tooltip';
      tooltipEl.style.position = 'absolute';
      tooltipEl.style.opacity = 0;
      tooltipEl.style.pointerEvents = 'none';
      tooltipEl.style.padding = '8px 12px';
      tooltipEl.style.background = 'rgba(0, 0, 0, 0.8)';
      tooltipEl.style.color = 'white';
      tooltipEl.style.borderRadius = '4px';
      tooltipEl.style.transition = 'opacity 0.2s ease';
      tooltipEl.style.fontSize = "14px";

      document.body.appendChild(tooltipEl);
    }
    return tooltipEl;
  }

  getAlertsForType(sensor, alertType) {

    let matchedAlerts = [];
    let alerts = sensor.alerts;

    for(let alert of alerts) {
      if(alert.reading_type === alertType) {
        matchedAlerts.push(alert);
      }
    }

    return matchedAlerts;

  }

  async getTooltipContents(alertType, sensorId) {

    let html = `<h4 class="text--light-grey" style="margin: 0 0 5px;">${prettyPrintKey(alertType)}</h4>`;
    let sensor = window.currentSensors[sensorId];

    if(!sensor) {
      return "Invalid sensor, please reload page";
    }

    let alerts = this.getAlertsForType(sensor, alertType);

    if(alertType === 'connection') {
      html += `<div><b>${window.currentSensors[sensorId].offline == 1 ? 'OFFLINE' : 'ONLINE'}</b></div>`;

      if(alerts.length === 0) {
        html += `<div style="font-weight: bold; color: red;">WARNING: no connection alerts set</div>`;
      }

      const r = await window.apiRequest('get', '/sensor/' + sensorId + '/last-offline', {}, {
        preferCache: true,
      });

      if(r.data.last_offline) {
        html += `
        <div>Last offline ${window.getUserTimezoneDate(r.data.last_offline).format('MMM DD, YYYY h:mm a')}</div>
        `;
      } else {
        html += 'This sensor has not gone offline';
      }
    } else if(alertType === 'power') {

      if((sensor.type === 'US' || sensor.type === 'EX')) {

        if(alerts.length === 0) {
          html += `<div style="font-weight: bold; color: red;">No power alerts set</div>`;
        }

        if(sensor.last_pwr == 1) {
          html += '<div>This sensor is using USB power</div>';
        } else {
          html += '<div>This sensor is using batteries</div>';
        }

      } else {
        html += '<div>This sensor does not<br/>support USB power</div>'
      }

    } else if(alertType === 'battery') {

      if(alerts.length === 0) {
        html += `<div style="font-weight: bold; color: red;">No low battery alerts set</div>`;
      }

      let battPct = window.getBatteryPercentageForSensor(sensor);

      html += `<div>Battery: ${battPct}%`;

      if(battPct < 10) {
        html += '<span class="text--red"> (CRITICAL)</span>';
      } else if(battPct < 30) {
        html += '<span class="text--red"> (LOW)</span>';
      }

      html += '</div>';

    } else {

      if(alerts.length === 0) {
        html += `<div style="font-weight: bold; color: red;">No ${prettyPrintKey(alertType).toLowerCase()} alerts set</div>`;
      }

    }

    return html;
  }

  // Display the tooltip next to the hovered element
  showTooltip(targetEl, alertType, sensorId) {
    const tooltipEl = this.createTooltipIfNotExists();

    // Generate a unique identifier for this tooltip request.
    this.requestCounter = (this.requestCounter || 0) + 1;
    const currentRequest = this.requestCounter;
    this.activeTooltipId = currentRequest;

    // Immediately display a loading placeholder.
    tooltipEl.innerHTML = '<div>Loading...</div>';

    // Get the bounding rectangle of the target element.
    const rect = targetEl.getBoundingClientRect();
    // Position the tooltip to the right of the element, with a small gap.
    const offset = 10;
    const tooltipLeft = rect.right + offset + window.pageXOffset;
    const tooltipTop = rect.top + window.pageYOffset;

    tooltipEl.style.left = tooltipLeft + 'px';
    tooltipEl.style.top = tooltipTop + 'px';
    tooltipEl.style.opacity = 1;

    // Begin fetching the full tooltip content in the background.
    // When the promise resolves, update the tooltip content only if it is still the active request.
    this.getTooltipContents(alertType, sensorId)
      .then(content => {
        if (this.activeTooltipId === currentRequest) {
          tooltipEl.innerHTML = content;
        }
      })
      .catch(err => {
        // Optionally handle errors and update the UI accordingly.
        if (this.activeTooltipId === currentRequest) {
          tooltipEl.innerHTML = '<div>Error loading content</div>';
        }
      });
  }

  // Hide the tooltip by reducing its opacity.
  // Also cancels any in-flight async update so it can't "re-orphan" itself.
  hideTooltip() {
    // invalidate any pending request
    this.activeTooltipId = -1;

    const tooltipEl = document.getElementById('enterprise-tooltip');
    if (tooltipEl) {
      tooltipEl.style.opacity = 0;
      tooltipEl.innerHTML = '';
    }
  }

  // Hard remove the tooltip element (useful before re-rendering the grid)
  clear() {
    // invalidate any pending request
    this.requestCounter = (this.requestCounter || 0) + 1;
    this.activeTooltipId = -1;

    const tooltipEl = document.getElementById('enterprise-tooltip');
    if (tooltipEl) tooltipEl.remove();
  }

}

export default EnterpriseAlertTooltips;
